var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4275 19.748L11.3272 11.8719L14.1105 14.6484L4.72125 19.8538C4.36463 20.0518 3.927 20.0484 3.57262 19.8459L3.4275 19.748ZM10.5307 11.0777L3 18.5859V3.5694L10.5307 11.0777ZM15.2355 7.9749L18.9142 10.0145C19.2765 10.2159 19.5004 10.5917 19.5004 11C19.5004 11.4084 19.2765 11.7842 18.9142 11.9855L15.1342 14.0803L12.1237 11.0777L15.2355 7.9749ZM3.34425 2.32515L3.57262 2.15415C3.927 1.95165 4.36463 1.94828 4.72125 2.14628L14.2117 7.4079L11.3272 10.2834L3.34425 2.32515Z",
    fill: "#0F0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.cace7b9192e494e00ae177c47af8d94b.svg";
export { ForwardRef as ReactComponent };